<template>
	<div class="admin-login">
		<NavBar loginPage="true" />
		<v-main>
			<LoginForm :afterRegistration="afterRegistration" :admin="true" />
		</v-main>
		<Footer :absolute="true" />
	</div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import Footer from "@/components/authentication/Footer.vue";
import LoginForm from "@/components/authentication/LoginForm.vue";

export default {
	name: "login",
	props: {
		afterRegistration: {
			default: false
		}
	},
	components: {
		NavBar,
		Footer,
		LoginForm
	}
};
</script>